var $ = require('jquery');

function EsvVereinsdaten() {
	$('#all').on('click', function () {
		$('input[name^="korrektur"]').attr('checked', true);
	});
}

module.exports = EsvVereinsdaten;
